import { useQuery } from '@tcs/common/hooks/useQuery';
import { RetrievedSearchItemType } from '@tcs/client-portal-common/components/molecules/Search/types';
import { Persona } from '@tcs/client-portal-api/types/Persona';
import { SearchType } from '@tcs/client-portal-api/types/SearchType';
import { Page } from '@tcs/client-portal-api/types/Page';
import useSession from './useSession';

interface Props {
  loading: boolean;
  data?: Page<RetrievedSearchItemType>[];
}

const searchNotEnabledPersonas = [Persona.Individual, Persona.Beneficiary];

export const useSearch = (
  searchValue: string,
  searchType: SearchType = SearchType.All,
  page = 1,
  pageSize = 10,
  includeAggregates = false,
  excludeCount = false
): Props => {
  // restrict search based on persona to avoid forbidden search
  const {
    claims: { clientPortalPersona: persona },
  } = useSession();
  const enabled =
    !searchNotEnabledPersonas.includes(persona) && searchValue.length >= 2;
  if (persona === Persona.Representative) {
    searchType = SearchType.Account;
  }

  const { data, isLoading: loading } = useQuery<
    Page<RetrievedSearchItemType>[],
    Error
  >(
    `/search?searchType=${searchType}&query=${searchValue.trim()}&pageSize=${pageSize}&page=${page}&includeAggregates=${includeAggregates}&excludeCount=${excludeCount}`,
    {
      refetchOnMount: false,
      enabled: enabled,
    }
  );

  return {
    loading: enabled && loading,
    data,
  };
};

export default useSearch;
